import { type AppConfig, parseConfig } from './env'

/** Configuration validée de l'environnement courant. Échoue au démarrage si elle est incomplète. */
export const config: AppConfig = parseConfig(import.meta.env)
